/** @jsx h */
/** @jsxFrag Fragment */
import useTranslations from '@global-footer/hooks/useTranslations';
import { getPreferredLang } from 'global-utils/get-language';
import { globalScope } from 'global-utils/globals';
import { Fragment, h } from 'preact';
import { useEffect } from 'preact/hooks';
import FooterRenderer from './components/FooterRenderer';
import { FooterTemplate } from './types';
import { buildFooterLabels } from './utils/build-labels';
import { updateGlobalFooterLabels } from './utils/build-global-footer-data';
import { buildItems } from './utils/build-items';

const lang = getPreferredLang();

interface AppProps {
  footerTemplate: FooterTemplate;
}

export const App = ({ footerTemplate }: AppProps) => {
  const {
    translations
  }: { translations: Record<string, string | { [key: string]: string }> } =
    useTranslations(lang);

  const items = buildItems(translations);

  useEffect(() => {
    globalScope.global_footer = updateGlobalFooterLabels(
      globalScope.global_footer,
      buildFooterLabels(translations)
    );
  }, [translations]);

  return <FooterRenderer template={footerTemplate} items={items} />;
};
